import { useRecoilValue, useSetRecoilState } from 'recoil'

import { TELECOM } from '@/shared/constants/common'
import { CMD_TYPE } from '@/shared/constants/common'
import { useAPI, useLoading, useModal } from '@/shared/hooks/index'
import { otpTelecom, otpTimeOut, otpTransctionID } from '@/shared/recoil/otp/atom'
import { refundCaptchaErr, refundCapthca, refundLGTerms } from '@/shared/recoil/user/atom'
import { withCaptchaForm, withRefundForm } from '@/shared/recoil/user/withRefund'
import { captureRefundTermsError } from '@/shared/utils/sentry/validation'
import { getRefundCompleteContents, getRefundCompleteTitle } from '@/utils/refundCompleteContents'

export const useRefundAPI = () => {
  const loading = useLoading()
  const api = useAPI()
  const setRefundTerms = useSetRecoilState(refundLGTerms)
  //캡차 인증 리코일
  const setRefundCaptcha = useSetRecoilState(refundCapthca)
  const captchaForm = useRecoilValue(withCaptchaForm)
  const setOtpTimeOut = useSetRecoilState(otpTimeOut)
  const setOtpTransactionID = useSetRecoilState(otpTransctionID)
  const refundForm = useRecoilValue(withRefundForm)
  const telecom = useRecoilValue(otpTelecom)
  const setRefundCaptchaErrMsg = useSetRecoilState(refundCaptchaErr)
  const modal = useModal()
  //환불 등록 리코일

  //약관 요청 (20250619 통신사 구분하여 약관조회 불가하여 LG 약관 유지)
  async function sendTerms() {
    loading.on()
    const result = await api.requestSRS<ResponseRefundTermsBody>(CMD_TYPE.LGUP_REFUND_TERMS, {})
    if (result) {
      loading.off()
      captureRefundTermsError(result)
      setRefundTerms(result)
      return true
    } else {
      loading.off()
      return false
    }
  }

  //캡차 생성
  async function generateCaptcha() {
    loading.on()
    const result = await api.requestSRS<ResponseRefundCaptchaBody>(CMD_TYPE.CREATE_CAPTCHA, {})
    if (result) {
      loading.off()
      setRefundCaptcha(result)
      return result
    } else {
      loading.off()
      return {
        CaptchaID: '',
        ImgB64: '',
      } as ResponseRefundCaptchaBody
    }
  }
  //캡차 인증
  async function certCaptcha(authToken: string, CaptchaTransID: string) {
    loading.on()
    const data: RequestRefundOtpBody = {
      Telecom: captchaForm.Telecom,
      CaptchaTransID,
      PNumber: captchaForm.PNumber,
      AuthType: captchaForm.AuthType,
      AuthToken: authToken,
      PCode: captchaForm.PCode,
    }
    const result = await api.requestSRS<ResponseRefundOtpBody | string>(
      CMD_TYPE.TELECOM_REFUND_CAPTCHA,
      data,
    )
    if (result) {
      if (typeof result !== 'string') {
        loading.off()
        setOtpTimeOut(result.TimeOut)
        setOtpTransactionID(result.TransactionID)
        setRefundCaptchaErrMsg('')
        modal.alert({
          title: '',
          contents: '인증번호가 성공적으로 전송됐습니다.',
        })
        return true
      } else {
        loading.off()
        return false
      }
    } else {
      loading.off()
      return false
    }
  }
  //환불 등록

  async function sendRefund() {
    loading.on()
    const result = await api.requestSRS<ResponseRefundRegistBody>(
      CMD_TYPE.TELECOM_REFUND_REG,
      refundForm,
    )
    if (result) {
      loading.off()
      const isSkt = telecom === TELECOM.SKT
      const todayCancelNote =
        result.UseDay === 0 ? '\n\n가입 당일 해지하신 고객님은 요금이 청구되지 않습니다.' : ''
      modal
        .alert({
          title: getRefundCompleteTitle(isSkt),
          contents: getRefundCompleteContents({
            isSkt,
            amount: result.Amount,
            bank: result.BankName,
            account: result.Accountnumber,
            name: result.AccountName,
            RegDT: result.RegDT,
            extraNote: todayCancelNote,
          }),
          isXBtn: false,
        })
        .then(() => window.location.reload())
      return true
    } else {
      loading.off()
      return false
    }
  }

  return {
    terms: sendTerms,
    generate: generateCaptcha,
    cert: certCaptcha,
    send: sendRefund,
  }
}
